//#region Util Imports

import * as moment from 'moment'
import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import ArrayStore from 'devextreme/data/array_store'
import DataSource from 'devextreme/data/data_source'

//#endregion

import { Api, LocalDictionaryFactory } from './../../api/api.module'
import { ColumnModel } from '../../api/api.models'
import { EventsNames } from '../../../helpers/events-names'
import { CommonHelper } from '../../../helpers/common-helper'
import { i18n } from '../../common/i18n/common.i18n'
import { DatePickerBridge } from '../date-picker/date-picker.directive'
import { OperatorLayoutSettings } from '../../../helpers/operator-layout-settings'
import { IUserSession, TemplateHelper, ConfigHelper } from '../../../helpers'

//#region Asset Imports

import './action-filters.scss'
import * as TEMPLATE from './action-filters.tpl.html'

//#endregion

export interface ActionSelectedFilters {
    selectedType: any
    selectedState: any
    selectedOperator: any
    selectedModule: any
    selectedDevice: any
    selectedLocation: any
    selectedMeter: any
    selectedFromDate: string
    selectedToDate: string
}

interface ActionFiltersScope extends ng.IScope {
    datePickerBridge: DatePickerBridge
    typeSelectBoxOptions: DevExpress.ui.dxSelectBoxOptions
    typeSelectBox: DevExpress.ui.dxSelectBox
    stateSelectBoxOptions: DevExpress.ui.dxSelectBoxOptions
    stateSelectBox: DevExpress.ui.dxSelectBox
    moduleSelectBoxOptions: DevExpress.ui.dxSelectBoxOptions
    moduleSelectBox: DevExpress.ui.dxSelectBox
    deviceNumberBoxOptions: DevExpress.ui.dxNumberBoxOptions
    deviceNumberBox: DevExpress.ui.dxNumberBox

    settingsPopoverOptions: DevExpress.ui.dxPopoverOptions
    settingsPopover: DevExpress.ui.dxPopover
    settingsButtonOptions: DevExpress.ui.dxButtonOptions

    refreshButtonOptions: DevExpress.ui.dxButtonOptions
    cancelButtonOptions: DevExpress.ui.dxButtonOptions
    cancelButtonDisabled: boolean

    selectedFilters: ActionSelectedFilters

    onLocationSelected: (locationId: number, dataType, locationName: string) => void
    onMeterSelected: (meterId: number, dataType, meterName: string) => void
    onOperatorSelected: (operatorId: number, dataType, operatorName: string) => void
}

export class ActionFiltersDirective implements ng.IDirective {
    constructor() { }

    scope = {
        popupId: '='
    }
    restrict = 'E'
    controller = ['$scope', '$q', '$timeout', 'api', 'localDictionary', 'userSession', ($scope: ActionFiltersScope, $q: ng.IQService, $timeout: ng.ITimeoutService, api: Api, localDictionary: LocalDictionaryFactory, userSession: IUserSession) => {
        var referenceTables = {}
        function loadReferenceTables() {
            var promises = [];
            var referenceArray = [
                { dataTypeId: 10120, referenceTypeId: 24 },
                { dataTypeId: 10121, referenceTypeId: 33 },
                { dataTypeId: 10124, referenceTypeId: 107 },
                { dataTypeId: CommonHelper.userColumnId, referenceTypeId: 1 }
            ]
            referenceArray.map(reference => {
                promises.push(localDictionary.getReferenceTable(reference.referenceTypeId, reference.dataTypeId))
            })

            var createSmallColumnModel = (columnModels: ColumnModel[]) => {
                var result = []
                if (columnModels) {
                    columnModels.forEach(col => {
                        result.push({
                            caption: col.caption,
                            id: col.id
                        })
                    })
                }
                return result
            }

            return $q.all(promises).then((tables: any[]) => {
                if (!tables)
                    return
                referenceTables[24] = tables[0] ? createSmallColumnModel(tables[0].selectBoxData) : null
                referenceTables[33] = tables[1] ? createSmallColumnModel(tables[1].selectBoxData) : null
                referenceTables[107] = tables[2] ? createSmallColumnModel(tables[2].selectBoxData) : null
                referenceTables[1] = tables[3] ? createSmallColumnModel(tables[3].selectBoxData) : null
                return
            })
        }

        $scope.cancelButtonDisabled = true

        $scope.selectedFilters = <ActionSelectedFilters>{}

        $scope.selectedFilters.selectedType = OperatorLayoutSettings.getSetting(OperatorLayoutSettings.ActionType, null)
        $scope.selectedFilters.selectedState = OperatorLayoutSettings.getSetting(OperatorLayoutSettings.ActionState, null)
        $scope.selectedFilters.selectedOperator = OperatorLayoutSettings.getSetting(OperatorLayoutSettings.ActionOperator, null)
        $scope.selectedFilters.selectedDevice = OperatorLayoutSettings.getSetting(OperatorLayoutSettings.ActionDeviceId, null)
        $scope.selectedFilters.selectedLocation = OperatorLayoutSettings.getSetting(OperatorLayoutSettings.ActionLocationId, null)
        $scope.selectedFilters.selectedMeter = OperatorLayoutSettings.getSetting(OperatorLayoutSettings.ActionMeterId, null)
        $scope.selectedFilters.selectedModule = OperatorLayoutSettings.getSetting(OperatorLayoutSettings.ActionModule, null)

        var dateFormat = window['simax'].getDateFormat('DATE_TIME_FORMAT_MOMENTJS')

        var fromDate = OperatorLayoutSettings.getSetting(OperatorLayoutSettings.ActionFromDate, null)
        if (!fromDate)
            $scope.selectedFilters.selectedFromDate = moment(new Date().setDate(new Date().getDate() - 6)).format(dateFormat)
        else
            $scope.selectedFilters.selectedFromDate = moment(fromDate, dateFormat).format(dateFormat)

        var toDate = OperatorLayoutSettings.getSetting(OperatorLayoutSettings.ActionToDate, null)
        if (!toDate)
            $scope.selectedFilters.selectedToDate = moment().format(dateFormat)
        else
            $scope.selectedFilters.selectedToDate = moment(toDate, dateFormat).format(dateFormat)

        $scope.onLocationSelected = (locationId: number, dataType, locationName: string) => {
            $scope.selectedFilters.selectedLocation = locationId ? { id: locationId, caption: locationName } : null
            OperatorLayoutSettings.setSetting(OperatorLayoutSettings.ActionLocationId, $scope.selectedFilters.selectedLocation)
        }

        $scope.onMeterSelected = (meterId: number, dataType, meterName: string) => {
            $scope.selectedFilters.selectedMeter = meterId ? { id: meterId, caption: meterName } : null
            OperatorLayoutSettings.setSetting(OperatorLayoutSettings.ActionMeterId, $scope.selectedFilters.selectedMeter)
        }

        $scope.onOperatorSelected = (operatorId: number, dataType, operatorName: string) => {
            $scope.selectedFilters.selectedOperator = operatorId ? { id: operatorId, caption: operatorName } : null
            OperatorLayoutSettings.setSetting(OperatorLayoutSettings.ActionOperator, $scope.selectedFilters.selectedOperator)
        }

        $scope.refreshButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.RENEW_BUTTON, userSession),
            onClick: () => {
                $scope.$emit(EventsNames.FILTERS_UPDATED, $scope.selectedFilters)

                OperatorLayoutSettings.setSetting(OperatorLayoutSettings.ActionDeviceId, $scope.selectedFilters.selectedDevice)
                OperatorLayoutSettings.setSetting(OperatorLayoutSettings.ActionType, $scope.selectedFilters.selectedType)
                OperatorLayoutSettings.setSetting(OperatorLayoutSettings.ActionState, $scope.selectedFilters.selectedState)
                OperatorLayoutSettings.setSetting(OperatorLayoutSettings.ActionModule, $scope.selectedFilters.selectedModule)

                $scope.cancelButtonDisabled = false
            },
            hint: i18n('Common', 'Refresh'),
            height: 36
        }

        $scope.cancelButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.CLOSE, userSession),
            onClick: () => {
                $scope.$emit(EventsNames.FILTERS_UPDATE_CANCEL)
                $scope.cancelButtonDisabled = true
            },
            bindingOptions: {
                disabled: 'cancelButtonDisabled'
            },
            hint: i18n('Common', 'Cancel'),
            height: 36
        }

        $scope.settingsButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.SETTINGS, userSession),
            hint: i18n('Common', 'MoreFilters'),
            onClick: () => {
                $scope.settingsPopover.toggle(true)
            },
            height: 36
        }

        $scope.settingsPopoverOptions = {
            width: 400,
            target: '.more-options-button',
            contentTemplate: 'settingsContent',
            onInitialized: e => {
                $scope.settingsPopover = e.component
            }
        }

        $scope.datePickerBridge = {
            fromDate: null,
            toDate: null,
            callback: (selectedPeriod) => {
                if (selectedPeriod.id == "latest") {
                    $scope.datePickerBridge.fromDate = new Date()
                    $scope.datePickerBridge.fromDate.setMonth($scope.datePickerBridge.toDate.getMonth() - 1)
                    $scope.datePickerBridge.fromDate.setHours(0, 0, 0, 0)
                    $scope.datePickerBridge.toDate = new Date()
                    $scope.datePickerBridge.toDate.setHours(23, 59, 59, 999)
                }
                var dateFormat = window['simax'].getDateFormat('DATE_TIME_FORMAT_MOMENTJS')
                $scope.selectedFilters.selectedFromDate = moment($scope.datePickerBridge.fromDate).format(dateFormat)
                $scope.selectedFilters.selectedToDate = moment($scope.datePickerBridge.toDate).format(dateFormat)
            },
            customPeriods: [
                {
                    id: "latest",
                    title: i18n('Common', 'Latest')
                }
            ],
            isSmallScreen: false
        }

        $scope.deviceNumberBoxOptions = {
            placeholder: i18n('Common', 'Select'),
            height: 36,
            width: '100%',
            min: 0,
            showSpinButtons: true,
            showClearButton: true,
            value: $scope.selectedFilters.selectedDevice,
            onValueChanged: e => {
                $scope.selectedFilters.selectedDevice = e.value
            }
        }

        loadReferenceTables().then(() => {
            $scope.typeSelectBoxOptions = {
                placeholder: i18n('Common', 'Select'),
                dataSource: new DataSource({
                    store: new ArrayStore(referenceTables[24]),
                    paginate: true
                }),
                onInitialized: e => {
                    $scope.typeSelectBox = e.component
                },
                onValueChanged: e => {
                    $scope.selectedFilters.selectedType = e.value ? _.find(referenceTables[24], (table: any) => {
                        return table.id == e.value
                    }) : null
                },
                value: $scope.selectedFilters.selectedType ? $scope.selectedFilters.selectedType.id : undefined,
                height: 36,
                width: '100%',
                valueExpr: 'id',
                displayExpr: 'caption',
                noDataText: i18n('Common', 'NoData'),
                searchEnabled: true,
                showClearButton: true
            }

            $scope.stateSelectBoxOptions = {
                placeholder: i18n('Common', 'Select'),
                dataSource: new DataSource({
                    store: new ArrayStore(referenceTables[107]),
                    paginate: true
                }),
                onInitialized: e => {
                    $scope.stateSelectBox = e.component
                },
                onValueChanged: e => {
                    $scope.selectedFilters.selectedState = e.value ? _.find(referenceTables[107], (table: any) => {
                        return table.id == e.value
                    }) : null
                },
                value: $scope.selectedFilters.selectedState ? $scope.selectedFilters.selectedState.id : undefined,
                height: 36,
                width: '100%',
                valueExpr: 'id',
                displayExpr: 'caption',
                noDataText: i18n('Common', 'NoData'),
                searchEnabled: true,
                showClearButton: true
            }

            $scope.moduleSelectBoxOptions = {
                placeholder: i18n('Common', 'Select'),
                dataSource: new DataSource({
                    store: new ArrayStore(referenceTables[33]),
                    paginate: true
                }),
                onInitialized: e => {
                    $scope.moduleSelectBox = e.component
                },
                onValueChanged: e => {
                    $scope.selectedFilters.selectedModule = e.value ? _.find(referenceTables[33], (table: any) => {
                        return table.id == e.value
                    }) : null
                },
                value: $scope.selectedFilters.selectedModule ? $scope.selectedFilters.selectedModule.id : undefined,
                height: 36,
                width: '100%',
                valueExpr: 'id',
                displayExpr: 'caption',
                noDataText: i18n('Common', 'NoData'),
                searchEnabled: true,
                showClearButton: true
            }
        })

        $scope.$on(EventsNames.DISABLE_CANCEL_BUTTON, (event, ...args) => {
            $scope.cancelButtonDisabled = true
        })

        $scope.$on(EventsNames.ACTION_FILTER_UPDATED, (event, ...args: any[]) => {
            if (args && args[0]) {
                $scope.selectedFilters = args[0]
                var selectedFilters: ActionSelectedFilters = args[0]

                resetDate(selectedFilters.selectedFromDate, selectedFilters.selectedToDate)
                if (!selectedFilters.selectedType)
                    resetValue($scope.typeSelectBox)
                if (!selectedFilters.selectedState)
                    resetValue($scope.stateSelectBox)
                if (!selectedFilters.selectedLocation)
                    $scope.selectedFilters.selectedLocation = null
                if (!selectedFilters.selectedDevice)
                    resetValue($scope.deviceNumberBox)
                if (!selectedFilters.selectedMeter)
                    $scope.selectedFilters.selectedMeter = null
                if (!selectedFilters.selectedOperator)
                    $scope.selectedFilters.selectedOperator = null
                if (!selectedFilters.selectedModule)
                    resetValue($scope.moduleSelectBox)
            }
        })

        $scope.$on(EventsNames.FILTERS_CREARED_REDIRECT, () => {
            $scope.selectedFilters = <ActionSelectedFilters>{}

            resetDate()
            resetValue($scope.typeSelectBox)
            resetValue($scope.stateSelectBox)
            resetValue($scope.deviceNumberBox)
            resetValue($scope.moduleSelectBox)
            $scope.selectedFilters.selectedOperator = null
            $scope.selectedFilters.selectedLocation = null
            $scope.selectedFilters.selectedMeter = null

            OperatorLayoutSettings.setSetting(OperatorLayoutSettings.ActionLocationId, null)
            OperatorLayoutSettings.setSetting(OperatorLayoutSettings.ActionMeterId, null)
            OperatorLayoutSettings.setSetting(OperatorLayoutSettings.ActionOperator, null)
        })

        var resetValue = (inputElement) => {
            if (inputElement)
                inputElement.option('value', null)
        }

        var resetDate = (fDate?, tDate?) => {
            var dateFormat = window['simax'].getDateFormat('DATE_TIME_FORMAT_MOMENTJS')

            var date = new Date()
            date.setHours(0, 0, 0, 0)
            var fD = moment(date.setDate(new Date().getDate() - 6))
            $scope.selectedFilters.selectedFromDate = fDate ? fDate : fD.format(dateFormat)
            var fromDate = fD.toDate()
            date = new Date()

            date.setHours(23, 59, 59, 999)
            var tD = moment(date)
            $scope.selectedFilters.selectedToDate = tDate ? tDate : tD.format(dateFormat)
            var toDate = tD.toDate()

            $scope.$broadcast(EventsNames.CHANGE_FROM_TO_DATE, fDate ? moment(fDate, dateFormat).format('YYYY-MM-DD HH:mm') : fromDate, tDate ? moment(tDate, dateFormat).format('YYYY-MM-DD HH:mm') : toDate)
        }

        $timeout(() => {
            $scope.$broadcast(EventsNames.CHANGE_FROM_TO_DATE, moment($scope.selectedFilters.selectedFromDate, dateFormat).format('YYYY-MM-DD HH:mm'), moment($scope.selectedFilters.selectedToDate, dateFormat).format('YYYY-MM-DD HH:mm'))
        })
    }]
    template = TEMPLATE
    transclude = true
}